import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class HolidayService extends BaseService {
  constructor(protected override http: HttpClient) {
    super(http, `${environment.apiBaseUrl}/holidays`);
  }

  getDates(): Observable<string[]> {
    return this.http.get<any>(`${environment.apiBaseUrl}/holidays`)
      .pipe(map(res => res || []));
  }

  saveDates(dates: string[]): Observable<any> {
    return this.http.post<any>(`${environment.apiBaseUrl}/holidays`, { dates });
  }
}
